import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, output, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatIcon } from '@angular/material/icon';

import { I18nModule, PaginationModel } from '@spartacus/core';
import { BREAKPOINT, BreakpointService } from '@spartacus/storefront';

@Component({
    selector: 'dp-carousel-switcher',
    imports: [MatIcon, NgClass, I18nModule],
    templateUrl: './carousel-switcher.component.html',
    styleUrl: './carousel-switcher.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DpCarouselSwitcherComponent {
  readonly pagination = input.required<PaginationModel>();
  readonly items: Signal<number[]> = computed(() =>
    new Array(this.pagination().totalPages).fill(0).map((_, index) => index),
  );
  readonly isMobile = toSignal(inject(BreakpointService).isDown(BREAKPOINT.md), { initialValue: false });
  changeActive = output<number>();

  onChangeSlide(value: string): void {
    this.changeActive.emit(Number(value));
  }
}
